module.exports = __webpack_public_path__ + "media/images/icons/outlined/comment-ec19ba2f0e93a2a38ceac268ded2e2c1.svg";